module.exports = __webpack_public_path__ + "static/media/product expensive.40e330db.jpg";